// regex matching ISO Date strings: https://stackoverflow.com/a/3143231
const ISO_DATE_REGEX = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/

/**
 * deserialize persisted ISO Date string into a proper JS Date object
 * for other values just return them
 * primarily meant as a JSON.parse reviver
 */
export const initISODate: SecondParam<typeof JSON.parse> = (key, value) => {
  if (typeof value === 'string' && ISO_DATE_REGEX.test(value)) {
    return new Date(value)
  }

  return value
}
